import type { MeResponse } from '@lunya/contracts'

import type { Gender, User } from '../../types'
import { endOfIsoDate } from '../../utils'
import { mapCityFromApi } from './mapCityFromApi'

const GENDER_FROM_API: Readonly<Record<string, Gender>> = { f: 'f', m: 'm' }

/** DTO бэка (snake_case) → клиентский `User`. Поля перечислены явно — `...spread` запрещён. */
export function mapUserFromApi(dto: MeResponse): User {
  return {
    id: dto.id,
    firstName: dto.first_name,
    gender: dto.gender ? (GENDER_FROM_API[dto.gender] ?? null) : null,
    photoUrl: dto.photo_url ?? undefined,
    username: dto.username ?? undefined,
    birthDate: new Date(dto.birth_date),
    birthTime: dto.birth_time ?? null,
    birthCityId: dto.birth_city_id ?? null,
    birthCity: dto.birth_city ? mapCityFromApi(dto.birth_city) : null,
    birthLat: dto.birth_lat ?? null,
    birthLon: dto.birth_lon ?? null,
    birthTz: dto.birth_tz ?? null,
    // Конец дня, а не его полночь: отпуск «до 20 августа» действует весь двадцатый (см.
    // endOfIsoDate). С полуночью UTC отпуск, включённый по сегодняшнее число, приезжал
    // обратно уже истёкшим, и свитчер оставался выключенным.
    vacationUntil: dto.vacation_until ? endOfIsoDate(dto.vacation_until) : null,
    forecastTime: dto.forecast_time,
    forecastEnabled: dto.forecast_enabled,
    linkLimit: dto.link_limit,
    onboardedAt: dto.onboarded_at ? new Date(dto.onboarded_at) : null,
    termsVersion: dto.terms_version ?? null,
    lastSeenAt: new Date(dto.last_seen_at),
    createdAt: new Date(dto.created_at),
  }
}
